export enum DesignPatterns {
  Factory = "Factory",
  AbstractFactory = "AbstractFactory",
  Builder = "Builder",
  Prototype = "Prototype",
  Singleton = "Singleton",
  Bridge = "Bridge",
  Decorator = "Decorator",
  Facade = "Facade",
  Flyweight = "Flyweight",
  Proxy = "Proxy",
  Composite = "Composite",
  ChainOfResponsibility = "Chain of Responsibility",
  Command = "Command",
  Iterator = "Iterator",
  Mediator = "Mediator",
  Memento = "Memento",
  Observer = "Observer",
  State = "State",
  Strategy = "Strategy",
  TemplateMethod = "Template Method",
  Visitor = "Visitor",
}
